class HsInfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-hs-infinite-grid]');
    this.next = this.querySelector('[data-hs-infinite-next]');
    this.sectionId = this.dataset.sectionId;
    this.loading = false;

    if (!this.grid || !this.next || !this.sectionId) return;

    this.onClick = this.onClick.bind(this);
    this.onIntersect = this.onIntersect.bind(this);
    this.next.addEventListener('click', this.onClick);

    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: '600px 0px',
    });
    this.observer.observe(this.next);
  }

  disconnectedCallback() {
    this.next?.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
  }

  onClick(event) {
    event.preventDefault();
    this.loadNext();
  }

  onIntersect(entries) {
    if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
  }

  async loadNext() {
    if (this.loading || !this.next?.href) return;

    const fallbackHref = this.next.href;
    this.loading = true;
    this.next.setAttribute('aria-busy', 'true');
    this.next.classList.add('is-loading');

    try {
      const fetchUrl = new URL(this.next.href, window.location.origin);
      fetchUrl.searchParams.set('section_id', this.sectionId);

      const response = await fetch(fetchUrl.toString());
      if (!response.ok) throw new Error('load failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector('[data-hs-infinite-grid]');
      const nextLink = doc.querySelector('[data-hs-infinite-next]');

      if (incoming) {
        incoming.querySelectorAll(':scope > li').forEach((item) => {
          this.grid.appendChild(item);
        });
      }

      if (nextLink?.getAttribute('href')) {
        this.next.setAttribute('href', nextLink.getAttribute('href'));
        this.next.removeAttribute('aria-busy');
        this.next.classList.remove('is-loading');
        this.loading = false;
      } else {
        this.finish();
      }
    } catch (error) {
      window.location.href = fallbackHref;
    }
  }

  finish() {
    this.observer?.disconnect();
    this.next?.remove();
    this.loading = false;
  }
}

if (!customElements.get('hs-infinite-scroll')) {
  customElements.define('hs-infinite-scroll', HsInfiniteScroll);
}
